import React from 'react'
import classes from './styles.module.scss'
// import { FormattedMessage } from 'react-intl'
// import messages from './messages'
import { Popover, List } from 'antd'
import _ from 'lodash'

const data = [
  { lang: 'en', title: 'English', icon: 'iconfont fill_icon font-24 iconLanguage-en' },
  { lang: 'ar', title: 'Arabic', icon: 'iconfont fill_icon font-24 iconLanguage-ar' },
]

export default class LanguageSwitcher extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
    }
  }

  handleVisibleChange = (visible) => {
    this.setState({ visible })
  }

  handleLanguageChange = (lang) => {
    localStorage.lang = lang
    window.location.reload()
  }

  render() {
    const { siteConfig } = this.props
    const lang = siteConfig.language
    return (
      <Popover
        arrowPointAtCenter
        placement='bottomRight'
        content={
          <List
            className={classes.componentsLanguageSwitcher}
            size='small'
            split={false}
            itemLayout='horizontal'
            dataSource={data}
            renderItem={(item) => {
              const actions = []
              if (lang === item.lang) {
                actions[0] = (
                  <span
                    key={1}
                    className='iconfont font-24 iconcomm-choose green'
                  />
                )
              }
              return (
                <List.Item
                  onClick={() => this.handleLanguageChange(item.lang)}
                  actions={actions}
                >
                  {item.title}
                </List.Item>
              )
            }}
          />
        }
        trigger='click'
        visible={this.state.visible}
        onVisibleChange={this.handleVisibleChange}
      >
        <span className={_.find(data, { lang: lang }).icon} />
      </Popover>
    )
  }
}
